import { render, staticRenderFns } from "./kwld.vue?vue&type=template&id=4a08f131&scoped=true&"
import script from "./kwld.vue?vue&type=script&lang=js&"
export * from "./kwld.vue?vue&type=script&lang=js&"
import style0 from "./kwld.vue?vue&type=style&index=0&id=4a08f131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08f131",
  null
  
)

export default component.exports